import React, { useEffect, useRef, useContext } from "react";
import { store } from "../context/store";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { LICENCE_KEY } from "../constants/charts";

am4core.useTheme(am4themes_animated);
am4core.addLicense(LICENCE_KEY);

export default function AmChartPie({
  chartId,
  width,
  height,
  chartData,
  categoryKey,
  valueKey,
  showLabels,
  onClick,
  keyPosition,
  innerRadius,
  innerLabel
}) {

  const chartRef = useRef(null);
  const globalState = useContext(store);

  useEffect(() => {
    if (!chartId || !chartData) return;

	const chart = am4core.create(chartId, am4charts.PieChart);

	   chart.data = chartData;
	   chart.innerRadius = am4core.percent(5);
	   chart.radius = am4core.percent(70);
	   chart.padding(0, 0, 0, 0);

	   const series = chart.series.push(new am4charts.PieSeries());
	   series.dataFields.category = categoryKey;
	   series.dataFields.value = valueKey;

	   // Remove labels on slices
	   series.labels.template.disabled = true;
	   series.ticks.template.disabled = true;

	   // Smooth animated entry
	   series.hiddenState.properties.opacity = 0;

	   // --- Base colours (mid-tones for legend / fallback) ---
	   series.colors.list = [
	     am4core.color("#36B4C4"), // teal-ish
	     am4core.color("#A776C0"), // purple
	     am4core.color("#4F9EC4"), // cyan-blue
	     am4core.color("#F09A4C"), // orange
	   ];

	   // --- Hub gradients (light -> dark, per cube) ---
	   const gradTeal = new am4core.LinearGradient();
	   gradTeal.addColor(am4core.color("#5CC6D0"));
	   gradTeal.addColor(am4core.color("#027C91"));
	   gradTeal.rotation = 90;

	   const gradPurple = new am4core.LinearGradient();
	   gradPurple.addColor(am4core.color("#B28AC6"));
	   gradPurple.addColor(am4core.color("#613379"));
	   gradPurple.rotation = 90;

	   const gradCyan = new am4core.LinearGradient();
	   gradCyan.addColor(am4core.color("#5AAED1"));
	   gradCyan.addColor(am4core.color("#005E8F"));
	   gradCyan.rotation = 90;

	   const gradOrange = new am4core.LinearGradient();
	   gradOrange.addColor(am4core.color("#F5A255"));
	   gradOrange.addColor(am4core.color("#BA4B07"));
	   gradOrange.rotation = 90;

	   // Apply gradients per slice index
	   series.slices.template.adapter.add("fill", (fill, target) => {
	     if (!target.dataItem) {
	       return fill;
	     }
	     const index = target.dataItem.index;
	     switch (index) {
	       case 0:
	         return gradTeal;
	       case 1:
	         return gradPurple;
	       case 2:
	         return gradCyan;
	       case 3:
	         return gradOrange;
	       default:
	         return fill;
	     }
	   });
	if(keyPosition){
	   // ----- SUPER COMPACT LEGEND -----
	   chart.legend = new am4charts.Legend();
	   chart.legend.position = "bottom";
	   chart.legend.fontSize = 9;
	   chart.legend.paddingTop = -5;
	   chart.legend.paddingBottom = 0;
	   chart.legend.maxHeight = 60;
	   chart.legend.scrollable = false;

	   // Bullet styling (tiny markers)
	   const markerTemplate = chart.legend.markers.template;
	   markerTemplate.width = 8;
	   markerTemplate.height = 8;
	   markerTemplate.strokeWidth = 0;

	   // Spacing between legend items
	   chart.legend.itemContainers.template.paddingTop = 0;
	   chart.legend.itemContainers.template.paddingBottom = 0;
	   chart.legend.itemContainers.template.paddingLeft = 4;
	   chart.legend.itemContainers.template.paddingRight = 4;
	   chart.legend.itemContainers.template.marginBottom = -2;
	}
	   return () => {
	     chart.dispose();
	   };

  }, [chartId, chartData, valueKey]);

  return <div id={chartId} style={{ width, height }} />;
}

